// The job lists, in display order, with only the fields the cross-list links
// need. Shared UI reads this instead of roles.js so that a page for one list
// does not bundle every other list's dataset; roles.test.js keeps it in sync
// with the role configs.
export const lists = [
  {slug: 'fde', listName: 'The FDE List', roleName: 'Forward Deployed Engineer'},
  {slug: 'new-grad', listName: 'The New Grad List', roleName: 'New Grad Software Engineer'},
  {slug: 'investment-banking', listName: 'The IB List', roleName: 'Investment Banking Analyst'},
  {slug: 'security-engineer', listName: 'The Security Engineer List', roleName: 'Security Engineer'},
  {slug: 'data-engineer', listName: 'The Data Engineer List', roleName: 'Data Engineer'},
  {slug: 'data-scientist', listName: 'The Data Scientist List', roleName: 'Data Scientist'},
  {slug: 'ml-engineer', listName: 'The ML Engineer List', roleName: 'Machine Learning Engineer'},
];

export const getJob = (role, slug) => role.jobs.find((job) => job.slug === slug);

export const getCollection = (role, slug) => role.collections.find((c) => c.slug === slug);
